import React from "react";

const StripSection = () => {
  return (
    <div className="strip-section section">
      <div className="container">
        <ul className="strip_section-row">
          <li>
            <div className="strip-box">
              <div className="title">2 & 3 BHK Homes</div>
              <div className="sub_title">Configuration</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">5 Acres </div>
              <div className="sub_title">Land Parcel</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">4 Iconic Towers - G+69 Storeys</div>
              <div className="sub_title">Floors</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">Now Launched - Bookings Open</div>
              <div className="sub_title">Project Status</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StripSection;
